import { formatNumber, formatPrice } from '@ab-core/functions';
import type { PositionPriceObject } from '@ab-core/graphql/dist/index';
import { Icon } from '@ab-core/icon';
import useText from '@ab-core/localization/src/useText';
import type { WithTestId } from '@ab-core/testing';
import Text, { FontTypes } from '@ab-core/text';
import type { ScalePrice } from '@ab-core/types/src';
import type { FC } from 'react';
import React from 'react';
import { Block, Colum, ScaleColumn } from '.././styled';

type ScalePricesType = WithTestId & {
    quantity: string | number;
    quantityUnit: string | undefined;
    headline?: string;
    id?: string;
} & PositionPriceObject;

const getScaleForSelectedQuantity = (
    quantity: number,
    scalePrices: ScalePrice[] | undefined,
    priceReference: number | undefined
): number | undefined => {
    let currentScaleQuantity = priceReference;

    scalePrices?.forEach((scalePrice: ScalePrice) => {
        if (scalePrice.quantity <= quantity) {
            currentScaleQuantity = scalePrice.quantity;
        }
    });

    return currentScaleQuantity;
};

export const ScalePrices: FC<ScalePricesType> = (props) => {
    const { headline, quantity, quantityUnit, priceObject, ...rest } = props;
    const currentScalePriceQuantity = getScaleForSelectedQuantity(
        quantity,
        priceObject?.scalePrices,
        priceObject?.priceReference
    );

    const headlineText = headline ? useText(headline) : useText('priceCalculation.scalePriceSavings');

    return (
        <>
            {priceObject?.scalePrices && (
                <>
                    <Block {...rest}>
                        <Colum>
                            <Text type={FontTypes.Subtitle} content={headlineText} />
                        </Colum>
                        <Colum>
                            <ScaleColumn>
                                <Icon
                                    name="Checkmark"
                                    color={
                                        currentScalePriceQuantity === priceObject.priceReference ? 'success' : 'white'
                                    }
                                />

                                <Text
                                    color={
                                        currentScalePriceQuantity === priceObject.priceReference ? 'black' : 'gray70'
                                    }
                                    content={`pro ${formatNumber(priceObject.priceReference)} ${quantityUnit}`}
                                />
                            </ScaleColumn>
                            {priceObject.value && (
                                <Text
                                    color={
                                        currentScalePriceQuantity === priceObject.priceReference ? 'black' : 'gray70'
                                    }
                                    content={formatPrice(priceObject.value)}
                                />
                            )}
                        </Colum>
                        <>
                            {priceObject?.scalePrices?.map((scalePrice, i) => (
                                <Colum key={i}>
                                    <ScaleColumn>
                                        <>
                                            <Icon
                                                name="Checkmark"
                                                color={
                                                    currentScalePriceQuantity === scalePrice.quantity
                                                        ? 'success'
                                                        : 'white'
                                                }
                                            />
                                        </>
                                        <Text
                                            color={
                                                currentScalePriceQuantity === scalePrice.quantity ? 'black' : 'gray70'
                                            }
                                            content={`ab ${formatNumber(scalePrice.quantity)} ${quantityUnit}`}
                                        />
                                    </ScaleColumn>
                                    <Text
                                        color={currentScalePriceQuantity === scalePrice.quantity ? 'black' : 'gray70'}
                                        content={formatPrice(scalePrice.value)}
                                    />
                                </Colum>
                            ))}
                        </>
                    </Block>
                </>
            )}
        </>
    );
};
